module.exports = __webpack_public_path__ + "img/Villa_Borna_16.b837c460.jpg";